import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {MessageService} from './../base/message.service'

import {Service} from './../base/service'
import {Loggers} from '../../../util/app-util'
import { concentracionEntity } from '../../../elements/riesgo-credito/entities_riesgos/entities_riesgos';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class ConcentracionService extends Service<concentracionEntity>{

  httpClient: HttpClient;
  constructor(
    http: HttpClient,
    messageService: MessageService,
    protected override logger: Loggers,
    cookiesService: CookieService
  ) { 
    super('concentracion','',http, messageService, logger, cookiesService);
    this.httpClient = http;
  }
  protected getParams(entity: concentracionEntity):HttpParams{
    let params: HttpParams = new HttpParams();
    if (null == entity){return params;}
    if (null != entity.InstitucionId){params = params.set('InstitucionId', entity.InstitucionId)}
    if (null != entity.Periodo){params = params.set('Periodo', entity.Periodo)}
    if (null != entity.ElementoAgrupador){params = params.set('ElementoAgrupador', `Nombre_${entity.ElementoAgrupador.toString()}`)}
    if (null != entity.NPeriodos){params = params.set('NPeriodos', entity.NPeriodos)}
    if (null != entity.NDatosLimite){params = params.set('NDatosLimite', entity.NDatosLimite)}
    // if (null != entity.BnIntereses){params = params.set('BnIntereses', entity.BnIntereses.toString())}
    return params;
  }
}
